/**
 * Tiny gated logger.
 *
 *   logger.debug(...)  ← per-frame / hot-path / verbose. No-op in prod.
 *   logger.info(...)   ← startup / config / one-shot events. No-op in prod.
 *   logger.warn(...)   ← always logs (real warnings go to telemetry/ops).
 *   logger.error(...)  ← always logs.
 *
 * Why: production builds were emitting hundreds of `[PERF]` / `[STATE]` /
 * `[INFO]`-prefixed lines per study load. Each `console.log` is small but
 * with the DevTools console open they trigger sync layout reflows; closed,
 * they still allocate strings. Net cost: tens of ms per study + a console
 * panel that's useless to debug from. Routing the verbose tier through a
 * no-op in production reclaims both.
 *
 * Use the bare `console.warn` / `console.error` for genuine problems —
 * those should always reach the user's console regardless of build.
 */

const isDev = import.meta.env.DEV;

// `bind(console)` keeps the call site (`console.log @ file:line`) in
// DevTools instead of pointing every log to logger.ts.
export const logger = {
  debug: isDev ? console.log.bind(console) : () => {},
  info: isDev ? console.info.bind(console) : () => {},
  warn: console.warn.bind(console),
  error: console.error.bind(console),
};
